import { createSearchBannerModule } from './factory/searchBanner';

export default createSearchBannerModule({
  apiType: 'db-hotels',
  amountLabelField: 'room_label',
  amountOptionsField: 'room_options',
  amountValueField: {
    getResponse: 'num_rooms',
    postRequest: 'num_rooms',
    postResponse: 'num_rooms',
  },
});
